import { Fragment } from 'react';

import Column, { ColumnsRow, ColumnsWrapper } from 'bloko/blocks/column';
import Gap from 'bloko/blocks/gap';
import { H1Section } from 'bloko/blocks/header';
import VSpacing from 'bloko/blocks/vSpacing';

import useTrls from 'hooks/translation/useTrls';

import { Header } from 'components/Header/Header';

const Unavailable = () => {
    const trl = useTrls();

    return (
        <Fragment>
            <Header />
            <ColumnsWrapper>
                <ColumnsRow>
                    <Column xs="4" s="8" m="12" l="16">
                        <Gap top bottom>
                            <H1Section>{trl('Unavailable.title')}</H1Section>
                            <VSpacing base={8} />
                            <p>{trl('Unavailable.text')}</p>
                        </Gap>
                    </Column>
                </ColumnsRow>
            </ColumnsWrapper>
        </Fragment>
    );
};

export default Unavailable;
